// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vCMz","location":"Header_location__1bUJz"};